import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { listFulfillmentRulesPageAccessControl } from '../access-control/listFulfillmentRulesPageAccess.configuration'
import { createFulfillmentRulePageAccessControl } from '../access-control/createFulfillmentRulePageAccess.configuration'
import { scopeRuleManagementPageAccessControl } from '../access-control/scopeRuleManagementPageAccess.configuration'
import { editFulfillmentRulePageAccessControl } from '../access-control/editFulfillmentRulePageAccess.configuration'
import { manageProvidersPageAccessControl } from '../access-control/manageProvidersPageAccess.configuration'
import { editProviderPageAccessControl } from '../access-control/editProviderPageAccess.configuration'

const ListFulfillmentRulesPage = lazy(() => import('../pages/ListFulfillmentRulesPage/page'))
const CreateFulfillmentRulePage = lazy(() => import('../pages/CreateFulfillmentRulePage/page'))
const ScopeRuleManagementPage = lazy(() => import('../pages/ScopeRuleManagementPage/page'))
const EditFulfillmentRulePage = lazy(() => import('../pages/EditFulfillmentRulePage/page'))
const ManageProvidersPage = lazy(() => import('../pages/ManageProvidersPage/page'))
const EditProviderPage = lazy(() => import('../pages/EditProviderPage/page'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const fulfillmentSettingsRouter = (
  <DomainRoute route="fulfillment-settings" accessControl={{}}>
    <DashSwitch>
      <DomainRoute
        exact
        route="fulfillment-settings-create-fulfillment-rule"
        component={CreateFulfillmentRulePage}
        accessControl={createFulfillmentRulePageAccessControl}
      />
      <DomainRoute
        exact
        route="fulfillment-settings-store-rule-management"
        component={ScopeRuleManagementPage}
        accessControl={scopeRuleManagementPageAccessControl}
      />
      <DomainRoute
        exact
        route="fulfillment-settings-banner-rule-management"
        component={ScopeRuleManagementPage}
        accessControl={scopeRuleManagementPageAccessControl}
      />
      <DomainRoute
        exact
        route="fulfillment-settings-edit-fulfillment-rule"
        component={EditFulfillmentRulePage}
        accessControl={editFulfillmentRulePageAccessControl}
      />
      <DomainRoute
        exact
        route="fulfillment-settings-list-fulfillment-rules"
        component={ListFulfillmentRulesPage}
        accessControl={listFulfillmentRulesPageAccessControl}
      />
      <DomainRoute
        exact
        route="fulfillment-settings-edit-provider"
        component={EditProviderPage}
        accessControl={editProviderPageAccessControl}
      />
      <DomainRoute
        exact
        route="fulfillment-settings-manage-providers"
        component={ManageProvidersPage}
        accessControl={manageProvidersPageAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
